var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionSchedule12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15 8.35l.7-.7L7 5.8V3.5H6v2.7l2.15 2.15zM6.5 11a4.866 4.866 0 01-1.95-.394 5.045 5.045 0 01-1.587-1.069A5.043 5.043 0 011.894 7.95 4.866 4.866 0 011.5 6c0-.692.131-1.342.394-1.95a5.046 5.046 0 011.069-1.587c.45-.45.979-.807 1.587-1.07A4.871 4.871 0 016.5 1c.692 0 1.342.131 1.95.393a5.053 5.053 0 011.588 1.07c.45.45.806.979 1.068 1.587.263.608.394 1.258.394 1.95s-.131 1.342-.394 1.95a5.045 5.045 0 01-1.069 1.587c-.45.45-.979.807-1.587 1.069A4.866 4.866 0 016.5 11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionSchedule12);
export default __webpack_public_path__ + "3d162602611443d16829d07da837afc1.svg";
export { ForwardRef as ReactComponent };